/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Table types for settings statistics
 *
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.1
 */



export enum ESettingsStatisticsField {
    DATE = 'date',
    IP_ADDRESS = 'ipAddress'
}

export interface ISettingsStatisticsTableData {
    [ESettingsStatisticsField.DATE]: number;
    [ESettingsStatisticsField.IP_ADDRESS]: string;
}

export const SettingsStatisticsColumnNames: ESettingsStatisticsField[] = [
    ESettingsStatisticsField.DATE,
    ESettingsStatisticsField.IP_ADDRESS,
];
